import { EnvironmentContext } from '@lattice/runtime'

export const AWSCognitoConfig = {
  UserPoolId: EnvironmentContext.cognitoUserPoolId,
  ClientId: EnvironmentContext.cognitoUserPoolClientId,
} as const
